import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ThumbsUpIcon } from 'lucide-react';
import { IMAGES, funnelSteps, retargetingAds } from '../data/funnel';
export function RetargetingPage() {
  const creatives: Record<string, string> = {
    'ad-1': IMAGES.cover,
    'ad-2': IMAGES.sarah,
    'ad-3': IMAGES.park
  };
  return <main className="w-full bg-cream pb-24" data-id="element-66" data-mp="zs1zzyizpbza">
      <div className="mx-auto max-w-6xl px-5 pt-12" data-id="element-67" data-mp="25mkh2a4ioed">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy/60 transition-colors duration-150 ease-out hover:text-navy-deep" data-id="element-68" data-mp="26xmoxnx7o3d">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-69" data-mp="c1zc7um3ys6h" />
          Volver al inicio del funnel
        </Link>

        <h1 className="mt-6 font-display text-[1.75rem] font-bold leading-tight text-navy-deep sm:text-[2.4rem]" data-id="element-70" data-mp="g67420nv4o8x">
          Secuencia de retargeting · $2 al día
        </h1>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy/70" data-id="element-71" data-mp="1rizv198tx8nx">
          Tres anuncios que cubren los 7 días posteriores a la visita. Cada uno ataca una objeción
          distinta y devuelve al usuario al punto exacto donde abandonó.
        </p>

        <section aria-label="Ruta del funnel" className="mt-8 flex flex-wrap items-center gap-2" data-id="element-72" data-mp="1wph3ctf918ti">
          {funnelSteps.filter(s => s.path.startsWith('/') && s.path !== '/retargeting').map(s => <React.Fragment key={s.path} data-id="element-73" data-mp="1nq438rd0lwlg">
                <Link to={s.path} className="rounded-full border border-navy-deep/15 bg-paper px-3.5 py-1.5 text-xs font-semibold text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-pale" data-id="element-74" data-mp="1nr5cqredub12">
                  {s.label}
                </Link>
                <span className="text-navy/30" data-id="element-75" data-mp="14yl2kr6gquml">→</span>
              </React.Fragment>)}
          <span className="rounded-full border border-navy-deep/15 bg-paper px-3.5 py-1.5 text-xs font-semibold text-navy-deep" data-id="element-76" data-mp="150e1tleqyckk">
            Checkout de Shopify
          </span>
        </section>

        <div className="mt-9 grid gap-6 lg:grid-cols-3" data-id="element-77" data-mp="qe8iauql4dpk">
          {retargetingAds.map(ad => <article key={ad.id} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper shadow-card" data-id="element-78" data-mp="ub4nv4p9x4zm">
              <div className="flex items-baseline justify-between gap-3 border-b border-navy-deep/10 px-5 py-3" data-id="element-79" data-mp="ldb1oml83rq6">
                <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-80" data-mp="194gip52wgq22">
                  {ad.window}
                </span>
                <span className="text-xs font-semibold text-navy/55" data-id="element-81" data-mp="zd29u6p26dw9">{ad.angle}</span>
              </div>

              <div className="p-5" data-id="element-82" data-mp="14avgf0u9x9x2">
                <div className="flex items-center gap-2.5" data-id="element-83" data-mp="149st12w5tplw">
                  <span className="grid h-8 w-8 place-items-center rounded-full bg-navy-deep font-display text-xs font-bold text-gold" data-id="element-84" data-mp="1s0y474r5ntpv">
                    FL
                  </span>
                  <div data-id="element-85" data-mp="3hhtpx3fdkfj6">
                    <p className="text-xs font-semibold text-navy-deep" data-id="element-86" data-mp="3hhbn1ny7j32a">Frenchie Longevity</p>
                    <p className="text-[11px] text-navy/45" data-id="element-87" data-mp="3ci7duxba95by">Publicidad</p>
                  </div>
                </div>

                <p className="mt-3 text-[0.9rem] leading-relaxed text-navy-deep/85" data-id="element-88" data-mp="3qa5gcpaho2z5">
                  {ad.primaryText}
                </p>
              </div>

              <img src={creatives[ad.id]} alt={`Creativo del anuncio: ${ad.headline}`} className="aspect-square w-full object-cover" data-id="element-89" data-mp="2yiz9lq09j70w" />

              <div className="flex items-center justify-between gap-3 bg-cream px-5 py-3.5" data-id="element-90" data-mp="37kp26z5vsc09">
                <p className="min-w-0 font-display text-sm font-bold leading-snug text-navy-deep" data-id="element-91" data-mp="32lcekc76r0wm">
                  {ad.headline}
                </p>
                <span className="shrink-0 rounded-md bg-navy-deep px-3 py-1.5 text-xs font-semibold text-paper" data-id="element-92" data-mp="msdjoxlequum">
                  {ad.cta}
                </span>
              </div>

              <dl className="mt-auto space-y-2 border-t border-navy-deep/10 px-5 py-4 text-xs" data-id="element-93" data-mp="1d6bqy1fypjvo">
                <div data-id="element-94" data-mp="1i4whf95ewp6x">
                  <dt className="font-semibold uppercase tracking-[0.12em] text-navy/45" data-id="element-95" data-mp="1i4d98k5kdf63">
                    Audiencia
                  </dt>
                  <dd className="mt-0.5 text-navy/70" data-id="element-96" data-mp="1s21377vciin7">{ad.audience}</dd>
                </div>
                <div data-id="element-97" data-mp="1w45w24dyzb8s">
                  <dt className="font-semibold uppercase tracking-[0.12em] text-navy/45" data-id="element-98" data-mp="1w4o19qim0zsu">
                    Creativo
                  </dt>
                  <dd className="mt-0.5 text-navy/70" data-id="element-99" data-mp="210wc4rpry6u7">{ad.creativeNote}</dd>
                </div>
              </dl>
            </article>)}
        </div>

        <p className="mt-8 flex items-start gap-2 text-sm leading-relaxed text-navy/60" data-id="element-100" data-mp="2arqxzuz3z4f4">
          <ThumbsUpIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/40" data-id="element-101" data-mp="2fsohcavuu4i7" />
          Reparto sugerido: $10/día al tráfico frío hacia la Bridge Page y $2/día repartidos entre
          estos tres anuncios, con exclusión de compradores en las tres audiencias.
        </p>
      </div>
    </main>;
}